import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
  toggleModal: false,
};

export default function operacaoprerecebimento(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoprerecebimento/FIND_PRERECEBIMENTO':
      case '@operacaoprerecebimento/UPDATE_PRERECEBIMENTO':
      case '@operacaoprerecebimento/DELETE_PRERECEBIMENTO':
      case '@operacaoprerecebimento/STORE_PRERECEBIMENTO':
      case '@operacaoprerecebimento/PRERECEBIMENTO_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaoprerecebimento/SUCCESS_REMOVE':
      case '@operacaoprerecebimento/FAILED_REQUEST': {
        draft.loading = false;

        break;
      }

      case '@operacaoprerecebimento/CLOSE_MODAL': {
        draft.toggleModal = action.payload.closeModal;
        break;
      }


      case '@operacaoprerecebimento/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaoprerecebimento;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoprerecebimento/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaoprerecebimento;
        break;
      }

      case '@operacaoprerecebimento/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        draft.toggleModal = false;
        break;
      }

      default:
    }
  });
}
